// src/pages/dashboard/HomePage.tsx
import { StarOutlined, ThunderboltOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AnimatedBackground from "../../components/common/AnimatedBackground";
import { RootState } from "../../store/index";

const Dashboard: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="min-h-full p-4 transition-all duration-500">
      <AnimatedBackground variant="dashboard" />

      <div className="relative z-10">
        <div
          className={`text-center mb-12 transform transition-all duration-1000 ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          }`}
        >
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-primary-500 to-red-600 rounded-full mb-6 animate-pulse">
            <StarOutlined className="text-3xl text-white" />
          </div>

          <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-primary-500 to-red-600 bg-clip-text text-transparent">
            Chào mừng {user?.user?.fullName}!
          </h1>

          <p className="text-xl text-gray-600 dark:text-gray-300 mb-2">
            Hệ thống Trace-Tec đang được phát triển
          </p>

          <div className="flex items-center justify-center gap-2 text-gray-500 dark:text-gray-400">
            <ThunderboltOutlined className="animate-pulse" />
            <span>Các tính năng mới sẽ sớm ra mắt</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
